import { translate } from "../../i18n/customI18nProvider";

export const fmt = (n) => new Intl.NumberFormat('fr-CH', { style: 'currency', currency: 'CHF' }).format(n);

export const getItem = (barInfo, id) => {
    let element =  barInfo.consumptions?.find((c) => c._id === id);
    if (!element) element = barInfo.deposits?.find((c) => c._id === id);
    return element;
}

export const computeTotal = (order, barInfo) => {
    if (!order || order.length === 0 || !barInfo || !Array.isArray(barInfo.consumptions)) return 0;
    let total = 0;
    for (const element of order) {
        const item = getItem(barInfo, element.id);
        if (item) {
            const price = Number(item.price || 0);
            const quantity = Number(element.quantity || 0);
            const deposit = barInfo.allDeposits?.find(d => d._id === item.deposit);
            const depositPrice = Number(deposit?.price || 0);
            total += price * quantity + depositPrice * quantity;
        }
    }
    return total;
}

export function generateTableBadges(items, eventName, barName) {
    const win = window.open("", "_blank");
    const doc = win.document;

    // STYLE
    const style = doc.createElement("style");
    style.innerHTML = `
        body {
            font-family: Arial;
            margin: 0;
            padding: 20px;
        }

        .page {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10mm;
        }

        .badge {
            width: 80mm;
            border: 1px solid black;
            padding: 4mm;
            box-sizing: border-box;
            position: relative;
            page-break-inside: avoid;
        }

        .title {
            text-align: center;
            font-weight: bold;
            font-size: 14px;
        }

        .subtitle {
            text-align: center;
            font-size: 12px;
            font-weight: bold;
            margin-top: 1mm;
            margin-bottom: 3mm;
        }

        .row {
            display: flex;
            gap: 5mm;
        }

        .qr-container {
            padding-left: 15px;
            padding-right: 15px;
        }

        .qr {
            width: 30mm;
            height: 30mm;
        }

        .table {
            font-size: 18px;
            font-weight: bold;
            width: 100%;
            height: auto;
        }

        .table-title {
            width: 100%;
            text-align: center;
            margin: 0px;
            height: 20px;
            color: #474747;
            font-size: 16px;
        }

        .table-number {
            text-align: center;
            height: 100%;
            transform: translateY(-20px);
            margin: 0px;
            align-content: center;
            font-size: 32px;
        }

        .event {
            width: 100%;
            text-align: center;
            font-size: 10px;
            color: darkgray;
            margin-top: 3mm;
        }

        .hint {
            width: 100%;
            text-align: center;
            font-size: 9px;
            margin-top: 1mm;
        }
    `;

    doc.head.appendChild(style);

    // PAGE
    const page = doc.createElement("div");
    page.className = "page";

    items.forEach((item) => {
        const badge = doc.createElement("div");
        badge.className = "badge";

        badge.innerHTML = `
            <div class="title">${barName}</div>
            <div class="subtitle">${translate("custom.scan_to_order")}</div>

            <div class="row">
                <div class="qr-container">
                    <img class="qr" src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(item.qrValue)}" />
                </div>

                <div class="table">
                    <p class="table-title">${translate("custom.table").toUpperCase()}</p>
                    <p class="table-number">${item.tableNumber}</p>
                </div>
            </div>

            <div class="event">${eventName}</div>
            <div class="hint">${translate("custom.scan_with_phone_camera")}</div>
        `;
        page.appendChild(badge);
    });

    const js = doc.createElement("script");
    js.innerHTML = `
        window.onload = function() {
            window.print();
        }
    `;
    
    doc.body.appendChild(page);
    doc.body.appendChild(js);

    win.document.close();

    setTimeout(() => {
        win.focus();
        win.print();
    }, 50);
}